const cards = document.querySelectorAll('.card');

cards.forEach((card) => {
  const openButton = card.querySelector('.card__front');
  const closeButton = card.querySelector('.card-block');

  openButton?.addEventListener('click', (e) => {
    cards.forEach((item) => {
      if (e.currentTarget === item) return;
      item.classList.remove('card--active')
    });
    card.classList.add('card--active');
  });


  closeButton?.addEventListener('click', (e) => {
    card.classList.remove('card--active');
  });

});

document.querySelectorAll('.product-content__faq').forEach((faq) => {
  const title = faq.querySelector('.product-content__faq-title');

  title.setAttribute('role', 'button');
  title.setAttribute('tabindex', '0');
  title.setAttribute('aria-expanded', 'false');

  const toggleFaq = () => {
    const isOpen = faq.classList.toggle('product-content__faq--open');
    title.setAttribute('aria-expanded', String(isOpen));
  };

  title.addEventListener('click', toggleFaq);
  title.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleFaq();
    }
  });
});

const productGallery = document.querySelector('.product-gallery');
const productGalleryMain = productGallery?.querySelector('.product-gallery__main');
const productGalleryThumbs = productGallery?.querySelector('.product-gallery__thumbs');

if (productGalleryMain && productGalleryThumbs && typeof window.Swiper === 'function') {
  const productGalleryThumbsSwiper = new Swiper(productGalleryThumbs, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 10,
    watchSlidesProgress: true,
    freeMode: true,
    breakpoints: {
      768: {
        direction: 'vertical',
        spaceBetween: 12,
      },
    },
  });

  new Swiper(productGalleryMain, {
    slidesPerView: 1,
    speed: 450,
    grabCursor: true,
    thumbs: {
      swiper: productGalleryThumbsSwiper,
      slideThumbActiveClass: 'product-gallery__thumb--active',
    },
  });
}

const mobileMenu = document.querySelector('.mobile-menu');
const mobileMenuBurger = document.querySelector('.header__burger');
const mobileMenuLinks = mobileMenu?.querySelectorAll('.js-mobile-menu-link');

const openMobileMenu = () => {
  if (!mobileMenu) return;

  mobileMenu.classList.add('mobile-menu--active');
  mobileMenu.setAttribute('aria-hidden', 'false');
  mobileMenuBurger?.setAttribute('aria-expanded', 'true');
  mobileMenuBurger?.setAttribute('aria-label', 'Close menu');
  mobileMenuBurger?.classList.add('header__burger--active');
  document.body.classList.add('menu-open');
};

const closeMobileMenu = (returnFocus = true) => {
  if (!mobileMenu) return;

  mobileMenu.classList.remove('mobile-menu--active');
  mobileMenu.setAttribute('aria-hidden', 'true');
  mobileMenuBurger?.setAttribute('aria-expanded', 'false');
  mobileMenuBurger?.setAttribute('aria-label', 'Open menu');
  mobileMenuBurger?.classList.remove('header__burger--active');
  document.body.classList.remove('menu-open');

  if (returnFocus) mobileMenuBurger?.focus();
};

mobileMenuBurger?.setAttribute('aria-controls', 'mobile-menu');
mobileMenuBurger?.setAttribute('aria-expanded', 'false');
mobileMenuBurger?.addEventListener('click', () => {
  if (mobileMenu?.classList.contains('mobile-menu--active')) {
    closeMobileMenu(false);
    return;
  }

  openMobileMenu();
});
mobileMenuLinks?.forEach((link) => {
  link.addEventListener('click', () => closeMobileMenu(false));
});

mobileMenu?.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeMobileMenu();
});

const initCosmosaursWaitlist = (modal) => {
  if (modal.dataset.initialized) return;
  const section = modal.closest('.shopify-section');
  const page = section?.querySelector('[data-cosmosaurs-page]');
  const form = modal.querySelector('[data-waitlist-form]');
  const input = form?.querySelector('[data-waitlist-email]');
  const submit = form?.querySelector('[data-waitlist-submit]');
  const error = form?.querySelector('[data-waitlist-error]');
  const offer = modal.querySelector('[data-waitlist-offer]');
  const success = modal.querySelector('[data-waitlist-success]');
  const block = modal.querySelector('[data-waitlist-block]');
  if (!page || !form || !input || !submit || !error || !offer || !success || !block) return;
  modal.dataset.initialized = 'true';

  const submitLabel = submit.textContent;
  const joinedEmails = new Set();
  let submitting = false;
  let trigger = null;

  const clearError = () => {
    error.hidden = true;
    error.textContent = '';
    input.removeAttribute('aria-invalid');
  };

  const showSuccess = () => {
    offer.hidden = true;
    success.hidden = false;
    block.setAttribute('aria-labelledby', success.querySelector('h2').id);
    block.setAttribute('aria-describedby', success.querySelector('p').id);
    if (modal.classList.contains('cosmosaurs-waitlist--active')) {
      success.querySelector('[data-waitlist-close]').focus({ preventScroll: true });
    }
  };

  const close = () => {
    modal.classList.remove('cosmosaurs-waitlist--active');
    document.body.classList.remove('cosmosaurs-waitlist-open');
    page.inert = false;
    const returnTarget = trigger?.getClientRects().length && !trigger.closest('.mobile-menu')
      ? trigger
      : page.querySelector('.header__burger');
    returnTarget?.focus({ preventScroll: true });
    modal.setAttribute('aria-hidden', 'true');
  };

  page.querySelectorAll('[data-waitlist-open]').forEach((button) => {
    button.addEventListener('click', () => {
      trigger = button;
      closeMobileMenu(false);
      clearError();
      offer.hidden = false;
      success.hidden = true;
      block.setAttribute('aria-labelledby', offer.querySelector('h2').id);
      block.setAttribute('aria-describedby', offer.querySelector('p').id);
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('cosmosaurs-waitlist--active');
      document.body.classList.add('cosmosaurs-waitlist-open');
      if (joinedEmails.has(input.value.trim().toLowerCase())) {
        showSuccess();
      } else {
        input.focus({ preventScroll: true });
      }
      page.inert = true;
    });
  });

  modal.querySelectorAll('[data-waitlist-close]').forEach((button) => button.addEventListener('click', close));
  section.addEventListener('shopify:section:unload', () => {
    if (modal.classList.contains('cosmosaurs-waitlist--active')) close();
  }, { once: true });
  modal.addEventListener('click', (event) => {
    if (event.target === modal) close();
  });
  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    }
    if (event.key !== 'Tab') return;
    const focusable = [...modal.querySelectorAll('button:not([disabled]), input:not([type="hidden"])')]
      .filter((element) => element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });

  input.addEventListener('input', clearError);
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submitting || !modal.classList.contains('cosmosaurs-waitlist--active')) return;
    clearError();
    input.value = input.value.trim();
    if (!input.checkValidity()) {
      error.textContent = form.dataset.invalidEmail;
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus({ preventScroll: true });
      return;
    }

    const email = input.value.toLowerCase();
    if (joinedEmails.has(email)) {
      showSuccess();
      return;
    }

    submitting = true;
    input.readOnly = true;
    submit.disabled = true;
    submit.textContent = form.dataset.sending;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || result?.success !== true) throw new Error(form.dataset.error);

      joinedEmails.add(email);
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: 'form_submited' });
      showSuccess();
    } catch (_error) {
      error.textContent = form.dataset.error;
      error.hidden = false;
    } finally {
      submitting = false;
      input.readOnly = false;
      submit.disabled = false;
      submit.textContent = submitLabel;
      form.removeAttribute('aria-busy');
    }
  });
};

document.querySelectorAll('[data-cosmosaurs-waitlist]').forEach(initCosmosaursWaitlist);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-cosmosaurs-waitlist]').forEach(initCosmosaursWaitlist);
});

const buyBlock = document.querySelector('.buy-block');
const buyBlockHiddenSections = [
  document.querySelector('.section--hero'),
  document.querySelector('.section--product'),
].filter(Boolean);
const BUY_BLOCK_HIDE_SCROLL_THRESHOLD = 28;
const BUY_BLOCK_SHOW_SCROLL_THRESHOLD = 4;
let lastWindowScroll = window.scrollY;
let buyBlockScrollFrame = null;

const isBuyBlockSectionVisible = () => buyBlockHiddenSections.some((section) => {
  const rect = section.getBoundingClientRect();

  return rect.top < window.innerHeight && rect.bottom > 0;
});

const updateBuyBlock = () => {
  if (!buyBlock) return;

  const currentScroll = window.scrollY;
  const scrollDifference = currentScroll - lastWindowScroll;
  const isHiddenSection = isBuyBlockSectionVisible();

  if (isHiddenSection || scrollDifference > BUY_BLOCK_HIDE_SCROLL_THRESHOLD) {
    buyBlock.classList.remove('buy-block--visible');
    lastWindowScroll = currentScroll;
  } else if (scrollDifference < -BUY_BLOCK_SHOW_SCROLL_THRESHOLD) {
    buyBlock.classList.add('buy-block--visible');
    lastWindowScroll = currentScroll;
  }

  buyBlockScrollFrame = null;
};

window.addEventListener('scroll', () => {
  if (buyBlockScrollFrame !== null) return;

  buyBlockScrollFrame = window.requestAnimationFrame(updateBuyBlock);
}, { passive: true });

updateBuyBlock();

const scrollVideo = document.querySelector('.illustration__block-video');

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const initScrollVideo = () => {
  if (!scrollVideo || !Number.isFinite(scrollVideo.duration) || scrollVideo.duration <= 0) return;

  const scrollVideoSeekEpsilon = 0.03;
  const scrollVideoSeekTimeout = 900;
  const scrollVideoRecoveryTimeout = 1200;
  let targetTime = scrollVideo.currentTime || 0;
  let scrollVideoFrame = null;
  let scrollVideoSeekStartedAt = 0;
  let scrollVideoSeekWatchdog = null;
  let scrollVideoRecovering = false;

  const getScrollVideoProgress = () => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const rect = scrollVideo.getBoundingClientRect();
    const startTop = viewportHeight;
    const endTop = viewportHeight * 0.3 - rect.height;
    const distance = startTop - endTop;

    if (distance <= 0) return 0;

    return clamp((startTop - rect.top) / distance, 0, 1);
  };

  const clearScrollVideoSeekWatchdog = () => {
    if (scrollVideoSeekWatchdog === null) return;

    window.clearTimeout(scrollVideoSeekWatchdog);
    scrollVideoSeekWatchdog = null;
  };

  const resetScrollVideoSeek = () => {
    scrollVideoSeekStartedAt = 0;
    clearScrollVideoSeekWatchdog();
  };

  const scheduleScrollVideoSeekWatchdog = () => {
    clearScrollVideoSeekWatchdog();
    scrollVideoSeekWatchdog = window.setTimeout(() => {
      scrollVideoSeekWatchdog = null;
      seekToTarget();
    }, scrollVideoSeekTimeout + 50);
  };

  const recoverScrollVideo = () => {
    if (scrollVideoRecovering) return;

    scrollVideoRecovering = true;
    resetScrollVideoSeek();

    let recoveryDone = false;
    const finishRecovery = () => {
      if (recoveryDone) return;

      recoveryDone = true;
      scrollVideoRecovering = false;
      requestScrollVideoUpdate();
    };

    scrollVideo.addEventListener('loadedmetadata', finishRecovery, { once: true });
    window.setTimeout(finishRecovery, scrollVideoRecoveryTimeout);

    scrollVideo.pause();
    scrollVideo.load();
  };

  const seekToTarget = () => {
    if (scrollVideoRecovering || !Number.isFinite(scrollVideo.duration) || scrollVideo.duration <= 0) {
      return;
    }

    const now = window.performance.now();

    if (scrollVideo.seeking) {
      if (scrollVideoSeekStartedAt === 0) {
        scrollVideoSeekStartedAt = now;
      }

      if (now - scrollVideoSeekStartedAt < scrollVideoSeekTimeout) {
        scheduleScrollVideoSeekWatchdog();
        return;
      }

      recoverScrollVideo();
      return;
    }

    if (Math.abs(scrollVideo.currentTime - targetTime) < scrollVideoSeekEpsilon) {
      resetScrollVideoSeek();
      return;
    }

    try {
      scrollVideo.currentTime = targetTime;
      scrollVideoSeekStartedAt = window.performance.now();
      scheduleScrollVideoSeekWatchdog();
    } catch (error) {
      recoverScrollVideo();
    }
  };

  const updateScrollVideo = () => {
    const scrollVideoDuration = Math.max(scrollVideo.duration - 0.05, 0);
    targetTime = scrollVideoDuration * getScrollVideoProgress();
    seekToTarget();
    scrollVideoFrame = null;
  };

  const requestScrollVideoUpdate = () => {
    if (scrollVideoFrame !== null) return;

    scrollVideoFrame = window.requestAnimationFrame(updateScrollVideo);
  };

  scrollVideo.addEventListener('seeking', () => {
    if (scrollVideoSeekStartedAt === 0) {
      scrollVideoSeekStartedAt = window.performance.now();
    }

    scheduleScrollVideoSeekWatchdog();
  });
  scrollVideo.addEventListener('seeked', () => {
    resetScrollVideoSeek();
    seekToTarget();
  });
  scrollVideo.addEventListener('loadedmetadata', requestScrollVideoUpdate);
  scrollVideo.addEventListener('loadeddata', requestScrollVideoUpdate);
  window.addEventListener('scroll', requestScrollVideoUpdate, { passive: true });
  window.addEventListener('resize', requestScrollVideoUpdate);
  requestScrollVideoUpdate();
};

if (scrollVideo) {
  if (scrollVideo.readyState >= 1) {
    initScrollVideo();
  } else {
    scrollVideo.addEventListener('loadedmetadata', initScrollVideo, { once: true });
  }

  document.addEventListener('touchstart', () => {
    scrollVideo.play().then(() => scrollVideo.pause()).catch(() => {});
  }, { once: true, passive: true });
}

const videoBlock = document.querySelector('.video');
const video = videoBlock?.querySelector('video');
const playButton = videoBlock?.querySelector('.video__play');
const videoPosterMedia = window.matchMedia('(max-width: 768px)');

const updateVideoPoster = () => {
  if (!video) return;

  const nextPoster = videoPosterMedia.matches
    ? video.dataset.mobilePoster
    : video.dataset.desktopPoster;

  if (nextPoster && video.getAttribute('poster') !== nextPoster) {
    video.setAttribute('poster', nextPoster);
  }
};

if (videoPosterMedia.addEventListener) {
  videoPosterMedia.addEventListener('change', updateVideoPoster);
} else {
  videoPosterMedia.addListener(updateVideoPoster);
}
updateVideoPoster();

playButton?.addEventListener('click', async () => {
  try {
    await video.play();
    videoBlock.classList.add('video--playing');
    video.setAttribute('controls', '');
  } catch (error) {
    videoBlock.classList.remove('video--playing');
  }
});

const slider = document.querySelector('.slider-cards');
const prevButton = document.querySelector('.slider-cards__arrow--prev');
const nextButton = document.querySelector('.slider-cards__arrow--next');
const sliderCards = slider ? [...slider.children] : [];
const reduceSliderMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let sliderMetrics = null;
let sliderPosition = 0;
let sliderTarget = 0;
let sliderVelocity = 0;
let sliderAnimationFrame = null;
let sliderDragging = false;
let sliderPointerId = null;
let sliderPointerX = 0;
let sliderPointerTime = 0;
let sliderResizeFrame = null;

const wrapSliderValue = (value, length) => {
  return ((value + length / 2) % length + length) % length - length / 2;
};

const mapSliderValue = (value, sourceMin, sourceMax, targetMin, targetMax) => {
  const progress = (value - sourceMin) / (sourceMax - sourceMin);

  return targetMin + progress * (targetMax - targetMin);
};

const parseSliderLength = (value, element) => {
  const trimmedValue = String(value || '').trim();
  const numericValue = parseFloat(trimmedValue);

  if (!Number.isFinite(numericValue)) return 0;
  if (trimmedValue.endsWith('rem')) {
    return numericValue * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }
  if (trimmedValue.endsWith('em')) {
    return numericValue * parseFloat(getComputedStyle(element).fontSize);
  }
  if (trimmedValue.endsWith('vw')) {
    return (numericValue / 100) * window.innerWidth;
  }
  if (trimmedValue.endsWith('vh')) {
    return (numericValue / 100) * window.innerHeight;
  }

  return numericValue;
};

const readSliderMetrics = () => {
  if (!slider || !sliderCards.length) return null;

  const styles = getComputedStyle(slider);
  const cardStyles = getComputedStyle(sliderCards[0]);
  const cardWidth = parseSliderLength(cardStyles.width, sliderCards[0]) || sliderCards[0].offsetWidth;
  const sliderWidth = slider.getBoundingClientRect().width;
  const gap = parseSliderLength(styles.getPropertyValue('--slider-card-gap'), slider);
  const pitchScale = parseFloat(styles.getPropertyValue('--slider-card-pitch-scale')) || 0;
  const compactGap = Math.min(gap, Math.max(16, Math.min(24, cardWidth * 0.055)));
  let pitch = cardWidth + gap;

  if (sliderWidth < 768 && pitchScale > 0) {
    pitch = Math.max(cardWidth, Math.min(pitch, cardWidth * pitchScale));
  } else if (sliderWidth >= 900) {
    const halfSliderWidth = sliderWidth / 2;
    const maxPitchForThreeFullCards = Math.max(0, halfSliderWidth - cardWidth / 2);
    const compactPitch = cardWidth + compactGap;

    pitch = Math.max(cardWidth, Math.min(compactPitch, maxPitchForThreeFullCards));
  }

  const loopWidth = pitch * sliderCards.length;
  const arcStep = parseSliderLength(styles.getPropertyValue('--slider-arc-step'), slider);

  return {
    cardWidth,
    pitch,
    loopWidth,
    circleDepth: arcStep * 4.2,
    rotateStep: parseFloat(styles.getPropertyValue('--slider-rotate-step')) || 0,
  };
};

const drawSlider = () => {
  if (!sliderMetrics) return;

  const { cardWidth, pitch, loopWidth, circleDepth, rotateStep } = sliderMetrics;

  sliderCards.forEach((card, index) => {
    const x = wrapSliderValue(index * pitch + sliderPosition, loopWidth);
    const circularAngle = (x / loopWidth) * Math.PI;
    const y = (1 - Math.cos(circularAngle)) * circleDepth;
    const maxRotation = rotateStep * Math.max(1, sliderCards.length / 2);
    const rotation = mapSliderValue(x, -loopWidth / 2, loopWidth / 2, -maxRotation, maxRotation);
    const depth = Math.cos(circularAngle);

    card.style.transform = `translate3d(${x - cardWidth / 2}px, ${y}px, 0) rotate(${rotation}deg)`;
    card.style.zIndex = String(Math.round(100 + depth * 100));
  });
};

const startSliderAnimation = () => {
  if (sliderAnimationFrame !== null) return;

  sliderAnimationFrame = window.requestAnimationFrame(animateSlider);
};

const animateSlider = () => {
  sliderAnimationFrame = null;

  if (!sliderDragging) {
    sliderTarget += sliderVelocity;
    sliderVelocity *= 0.92;
  }

  sliderPosition += (sliderTarget - sliderPosition) * (sliderDragging ? 0.3 : 0.12);
  drawSlider();

  const isMoving = Math.abs(sliderTarget - sliderPosition) > 0.1 || Math.abs(sliderVelocity) > 0.1;

  if (isMoving) startSliderAnimation();
};

const moveSliderByCard = (direction) => {
  if (!sliderMetrics) return;

  sliderVelocity = 0;
  sliderTarget += direction * sliderMetrics.pitch;

  if (reduceSliderMotion.matches) {
    sliderPosition = sliderTarget;
    drawSlider();
    return;
  }

  startSliderAnimation();
};

const resizeSlider = () => {
  if (!slider) return;

  const previousPitch = sliderMetrics?.pitch;
  const centeredCardPosition = previousPitch ? Math.round(sliderPosition / previousPitch) : 0;

  sliderMetrics = readSliderMetrics();
  if (!sliderMetrics) return;

  sliderVelocity = 0;
  sliderPosition = centeredCardPosition * sliderMetrics.pitch;
  sliderTarget = sliderPosition;
  drawSlider();
};

const requestSliderResize = () => {
  if (sliderResizeFrame !== null) return;

  sliderResizeFrame = window.requestAnimationFrame(() => {
    sliderResizeFrame = null;
    resizeSlider();
  });
};

sliderCards.forEach((card) => {
  card.querySelectorAll('img').forEach((image) => {
    image.setAttribute('draggable', 'false');
    image.addEventListener('load', requestSliderResize, { once: true });
  });
});

slider?.addEventListener('pointerdown', (event) => {
  if (event.button !== 0) return;

  sliderDragging = true;
  sliderPointerId = event.pointerId;
  sliderPointerX = event.clientX;
  sliderPointerTime = performance.now();
  sliderVelocity = 0;
  sliderTarget = sliderPosition;
  slider.classList.add('slider-cards--dragging');
  slider.setPointerCapture(event.pointerId);
});

slider?.addEventListener('pointermove', (event) => {
  if (!sliderDragging || event.pointerId !== sliderPointerId) return;

  const now = performance.now();
  const delta = event.clientX - sliderPointerX;
  const elapsed = Math.max(8, now - sliderPointerTime);

  sliderTarget += delta;
  sliderVelocity = (delta / elapsed) * 16;
  sliderPointerX = event.clientX;
  sliderPointerTime = now;
  startSliderAnimation();
});

const releaseSlider = (event) => {
  if (!sliderDragging || event.pointerId !== sliderPointerId) return;

  sliderDragging = false;
  sliderPointerId = null;
  slider.classList.remove('slider-cards--dragging');
  startSliderAnimation();
};

slider?.addEventListener('pointerup', releaseSlider);
slider?.addEventListener('pointercancel', releaseSlider);
slider?.addEventListener('lostpointercapture', () => {
  sliderDragging = false;
  sliderPointerId = null;
  slider?.classList.remove('slider-cards--dragging');
});
slider?.addEventListener('dragstart', (event) => event.preventDefault());
slider?.addEventListener('keydown', (event) => {
  if (event.key === 'ArrowLeft') {
    event.preventDefault();
    moveSliderByCard(1);
  }

  if (event.key === 'ArrowRight') {
    event.preventDefault();
    moveSliderByCard(-1);
  }
});

prevButton?.addEventListener('click', () => moveSliderByCard(1));
nextButton?.addEventListener('click', () => moveSliderByCard(-1));

window.addEventListener('resize', () => {
  requestSliderResize();

  if (window.innerWidth > 1024) closeMobileMenu(false);
});
window.addEventListener('orientationchange', requestSliderResize);

if (slider && 'ResizeObserver' in window) {
  const sliderResizeObserver = new ResizeObserver(requestSliderResize);
  sliderResizeObserver.observe(slider);
  if (sliderCards[0]) sliderResizeObserver.observe(sliderCards[0]);
}

if (document.fonts?.ready) {
  document.fonts.ready.then(requestSliderResize).catch(() => {});
}
resizeSlider();



(() => {
  const pageHeader = document.querySelector(".section--header");

  if (!pageHeader) return;

  const tabletHeaderMedia = window.matchMedia("(max-width: 1024px)");
  let lastHeaderScroll = window.scrollY;
  let headerScrollFrame = null;

  const updateHeaderVisibility = () => {
    const currentScroll = window.scrollY;
    const scrollDifference = currentScroll - lastHeaderScroll;
    const isMenuOpen = document.body.classList.contains("menu-open");
    const isHeaderScrolled =
      tabletHeaderMedia.matches && currentScroll > 16;

    pageHeader.classList.toggle(
      "section--header--scrolled",
      isHeaderScrolled,
    );

    if (!tabletHeaderMedia.matches || isMenuOpen || currentScroll <= 16) {
      pageHeader.classList.remove("section--header--hidden");
    } else if (scrollDifference > 4) {
      pageHeader.classList.add("section--header--hidden");
    } else if (scrollDifference < -4) {
      pageHeader.classList.remove("section--header--hidden");
    }

    if (Math.abs(scrollDifference) > 4) {
      lastHeaderScroll = currentScroll;
    }

    headerScrollFrame = null;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (headerScrollFrame !== null) return;

      headerScrollFrame = window.requestAnimationFrame(
        updateHeaderVisibility,
      );
    },
    { passive: true },
  );

  tabletHeaderMedia.addEventListener("change", () => {
    lastHeaderScroll = window.scrollY;
    updateHeaderVisibility();
  });

  updateHeaderVisibility();
})();
